/**
 * 效果预览悬浮窗中的演示视频（人物向示意，非用户成片）。
 * - 优先：fetchVideoConceptAiPreview 返回的 URL（真实 AI 预览）
 * - 其次：Mixkit 人物/时尚短片（联网；旧 /preview/ 路径已 403，使用 /videos/{id}/…）
 * - 末位：本地 concept-demo.mp4、Google 示例（兜底）
 */

function publicAsset(path) {
  const base =
    typeof process !== 'undefined' && process.env.PUBLIC_URL != null
      ? String(process.env.PUBLIC_URL).replace(/\/$/, '')
      : '';
  const rel = path.startsWith('/') ? path : `/${path}`;
  const url = `${base}${rel}`;
  return url.replace(/([^:])\/{2,}/g, '$1/');
}

const LOCAL_CONCEPT_DEMO = publicAsset('/video-concept-previews/concept-demo.mp4');

/** Mixkit 人物类预览片（新 CDN：/videos/{id}/{id}-720.mp4；旧 /preview/ 已 403） */
const MIXKIT_HUMAN_POOL = [
  'https://assets.mixkit.co/videos/44242/44242-720.mp4',
  'https://assets.mixkit.co/videos/42756/42756-720.mp4',
  'https://assets.mixkit.co/videos/43462/43462-720.mp4',
];

const PRESET_ORDER = ['natural', 'casual', 'magazine', 'closeup', 'catwalk'];

function humanStockUrlsForPreset(presetId) {
  const idx = PRESET_ORDER.indexOf(presetId);
  const shift = idx >= 0 ? idx : 0;
  const n = MIXKIT_HUMAN_POOL.length;
  return [...Array(n)].map((_, i) => MIXKIT_HUMAN_POOL[(shift + i) % n]);
}

const LEGACY_GOOGLE_SAMPLES = {
  natural: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4',
  casual: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4',
  magazine: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4',
  closeup: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4',
  catwalk: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4',
};

/**
 * @param {string} presetId
 * @param {{ aiPreviewUrl?: string | null }} [options]
 * @returns {string[]}
 */
export function getConceptPreviewVideoSources(presetId, options = {}) {
  const aiPreviewUrl = options.aiPreviewUrl && String(options.aiPreviewUrl).trim();
  const human = humanStockUrlsForPreset(presetId);
  const tail = LEGACY_GOOGLE_SAMPLES[presetId];
  const combined = [
    ...(aiPreviewUrl ? [aiPreviewUrl] : []),
    ...human,
    LOCAL_CONCEPT_DEMO,
    tail,
  ].filter(Boolean);
  return [...new Set(combined)];
}

/** @deprecated */
export const VIDEO_CONCEPT_PRESET_PREVIEW_VIDEO_URLS = LEGACY_GOOGLE_SAMPLES;
